export default "__VITE_ASSET__7b8bb624__"